import clsx from "clsx";
import { ragToBgClassMap } from "../../constants";

export type CertaintyRagChipProps = {
    red: number;
    amber: number;
};

const baseClasses = "text-center rounded-full text-xs py-1";

const CertaintyRagChip = ({ red, amber }: CertaintyRagChipProps) => {
    if (red !== 0) {
        return (
            <div
                className={clsx(
                    baseClasses,
                    ragToBgClassMap["red"],
                    "text-white"
                )}
            >
                {red} Poor
            </div>
        );
    }

    if (amber !== 0) {
        return (
            <div className={clsx(baseClasses, ragToBgClassMap["amber"])}>
                {amber} Fair
            </div>
        );
    }

    return (
        <div className={clsx(baseClasses, ragToBgClassMap["green"])}>
            All OK
        </div>
    );
};

export default CertaintyRagChip;
